import BenchlingConfig from 'BenchlingConfig';
import {
  createShadowEvaluationSnapshot,
  ShadowEvaluationSnapshot,
} from 'notebook/structured-tables/StructuredTableDAO';
import {EntryNote} from 'notebook/util/NoteUtilConstants';

export interface ShadowEvaluationSample {
  documentApiId: string;
  documentVersionId: number;
  documentName: string;
  note: EntryNote;
}

export function buildShadowEvaluationSnapshot({
  documentApiId,
  documentVersionId,
  documentName,
  note,
}: ShadowEvaluationSample): ShadowEvaluationSnapshot | null {
  const nrs = note.noteRuntimeSnapshot;
  if (nrs == null || nrs.evaluationSnapshot == null || nrs.prevQueryResolutions == null) {
    return null;
  }
  return {
    documentApiId,
    documentName,
    versionId: documentVersionId,
    excessVersion: nrs.excessVersion ?? '',
    queryResolutions: nrs.queryResolutions,
    prevQueryResolutions: nrs.prevQueryResolutions,
  };
}

export function sampleForShadowEvaluation(sample: ShadowEvaluationSample): void {
  if (BenchlingConfig.ELN_SHADOW_EVALUATION_SAMPLE_RATE <= Math.random()) {
    return;
  }
  const snapshot = buildShadowEvaluationSnapshot(sample);
  if (snapshot == null) {
    return;
  }
  createShadowEvaluationSnapshot({shadowEvaluationSnapshots: [snapshot]});
}

export function sampleManyForShadowEvaluation(samples: Array<ShadowEvaluationSample>): void {
  if (BenchlingConfig.ELN_SHADOW_EVALUATION_SAMPLE_RATE <= Math.random()) {
    return;
  }
  const shadowEvaluationSnapshots: Array<ShadowEvaluationSnapshot> = [];
  for (const sample of samples) {
    const snapshot = buildShadowEvaluationSnapshot(sample);
    if (snapshot == null) {
      return;
    }
    shadowEvaluationSnapshots.push(snapshot);
  }
  if (shadowEvaluationSnapshots.length === 0) {
    return;
  }
  createShadowEvaluationSnapshot({shadowEvaluationSnapshots});
}
